import React from 'react'
import styles from './ShinglesIndices.module.scss'
import Content from '../../components/Content'
import Layout from '../../components/Layout'
import GeoProvider from '../../components/GeoProvider'
import dataDisplayOptions from './dataDisplayOptions'
import { startDate, endDate, displayDate } from './dates'
import DashboardMap from './DashboardMap'
import VaccineTable from './VaccineTable'
import Header from './Header'
import AgeGenderGraph from './AgeGenderGraph'

const ShinglesDashboard = () => {
  return (
    <Layout>
      <Content>
        <div className={styles.base}>
          <div className={styles.body}>
            <GeoProvider
              startDate={startDate}
              endDate={endDate}
              displayDate={displayDate}
              locationName={"nat"}
              mapOptions={dataDisplayOptions[0]['options'][0]}
              indicatorName={dataDisplayOptions[0]['options'][0].indicatorName}
              regionSelected={'state'}
            >
              <Header headerType="nat" headerNumber={1}  geo_id="nat"/>
              <DashboardMap 
                geo_type={'nat'}
                geo_parent={'nat'}
                zoomLocation={'nat'} />
                <VaccineTable/> 
               <AgeGenderGraph/>
            </GeoProvider>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default ShinglesDashboard
